import React, {useEffect, useState} from 'react'
import {getAllCustomer} from "../../services/serviceCustomer";
import {getAllProductionLine} from "../../services/serviceProductionLine";
import {createAll} from "../../services/serviceProduction";
import {AutoComplete, DatePicker, Form, Modal, Input, Button, InputNumber, message} from "antd";
import {getAllRecipes, recipeStockList} from "../../services/serviceRecipe";
import ProductionStockWarehouse from "./ProductionStockWarehouse";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const {Option} = AutoComplete
const {TextArea} = Input
const dateFormat = 'DD/MM/YYYY'


const ProductionCreate = ({show, modalCloser, updater}) => {
    const [form] = Form.useForm()
    const [recipes, setRecipes] = useState([])
    const [customers, setCustomers] = useState([])
    const [productionLines, setProductionLines] = useState([])
    const [selectedRecipe, setSelectedRecipe] = useState()
    const [selectedCustomer, setSelectedCustomer] = useState()
    const [selectedProdLine, setSelectedProdLine] = useState(null)
    const [recipeStocks, setRecipeStocks] = useState([])
    const [bulkList, setBulkList] = useState([])
    const [loadings, setLoadings] = useState([])

    useEffect(() => {
        getAllRecipes()
            .then(({data}) => {
                let recipeData = []
                data.forEach(item => {
                    let recipeItem = {
                        text: item.code,
                        value: item.id
                    }
                    recipeData.push(recipeItem)
                })
                setRecipes(recipeData)
            })

        getAllCustomer()
            .then(({data}) => {
                let customerData = []
                data.forEach(item => {
                    let customerItem = {
                        text: item.name,
                        value: item.id
                    }
                    customerData.push(customerItem)
                })
                setCustomers(customerData)
            })

        getAllProductionLine()
            .then(({data}) => {
                let productionLineData = []
                data.forEach(item => {
                    let prodItem = {
                        text: item.name,
                        value: item.id
                    }
                    productionLineData.push(prodItem)
                })
                setProductionLines(productionLineData)
            })
    }, [])

    const handleBulkList = (stockId, warehouseId) => {
        const mockList = bulkList
        const matchedItem = mockList.find(item => item.stock.id === stockId)

        if (matchedItem && warehouseId) {
            matchedItem.warehouse.id = warehouseId
            setBulkList([...mockList])
            return
        }

        if (matchedItem && !warehouseId) {
            mockList.splice(mockList.indexOf(matchedItem), 1)
            setBulkList([...mockList])
            return
        }

        mockList.push({
            stock: {
                id: stockId
            },
            warehouse: {
                id: warehouseId
            }
        })
        setBulkList([...mockList])
    }
    const handleRecipeChange = (value, {key}) => {
        if (key) {
            recipeStockList(key)
                .then(({data}) => setRecipeStocks(data))
            setSelectedRecipe(key)
        }
    }
    const isEndDateBigger = (startDate, endDate) => endDate >= startDate
    const handleCustomerChange = (v, o) => setSelectedCustomer(o.key)
    const handleProdChange = (v, o) => setSelectedProdLine(o.key)
    const handleSubmit = () => {
        enterLoadingState(setLoadings)
        if (bulkList.length) {
            const {
                productionNotes,
                productionStartDate,
                productionEndDate,
                quantity
            } = form.getFieldsValue()

            let requestObj = {
                customer: {id: selectedCustomer},
                endDate: productionEndDate._d,
                note: productionNotes,
                productionLine: selectedProdLine === null ? null : {id: selectedProdLine},
                productionStockDTOS: bulkList,
                quantity: quantity,
                recipe: {id: selectedRecipe},
                startDate: productionStartDate._d,
            }

            if (!isEndDateBigger(requestObj.startDate, requestObj.endDate)) {
                message.warning('Üretim Başlangıç Tarihi, Bitiş Tarihinden Önce Olmalıdır')
                return
            }

            createAll(requestObj)
                .then(() => {
                    exitLoadingState(setLoadings)
                    modalCloser()
                    updater()
                })
                .catch(() => exitLoadingState(setLoadings))
            return
        }

        message.warning('Seçtiğiniz Reçetenin Kalemlerine Ait Stok Bilgisi Bulunamadı')
    }

    return (
        <React.Fragment>
            <Modal
                open={show}
                closable={false}
                title={'Üretim Emri Ekle'}
                footer={[
                    <Button
                        key={'SubmitButton'}
                        type={'primary'}
                        loading={loadings[0]}
                        onClick={() => form.submit()}
                    >
                        Kaydet
                    </Button>,
                    <Button
                        key={'CancelButton'}
                        onClick={modalCloser}>
                        Kapat
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    onFinish={handleSubmit}
                    labelCol={{span: 6}}
                    wrapperCol={{span: 18}}
                    labelAlign={'left'}
                >
                    <Form.Item
                        label={'Reçete'}
                    >
                        <AutoComplete
                            style={{minWidth: '75px'}}
                            onChange={handleRecipeChange}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {recipes.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        label={'Müşteri'}
                    >
                        <AutoComplete
                            style={{minWidth: '75px'}}
                            onChange={handleCustomerChange}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {customers.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                    {
                        recipeStocks.length ?
                            <React.Fragment>
                                {
                                    recipeStocks.map((item, index) => {
                                        return <ProductionStockWarehouse key={index} index={index}
                                                                         productionItem={item}
                                                                         stockId={item.id}
                                                                         stockLabel={`${item.code} - ${item.name}`}
                                                                         handler={handleBulkList}/>
                                    })
                                }
                            </React.Fragment> : null
                    }
                    <Form.Item
                        label={'Miktar'}
                        name={'quantity'}
                        rules={[
                            {required: true, message:'Bu Alan boş Bırakılamaz'}
                        ]}
                    >
                        <InputNumber
                            step={0.1}
                            min={0}
                        />
                    </Form.Item>
                    <Form.Item
                        label={'Başlangıç Tarihi'}
                        name={'productionStartDate'}
                        rules={[
                            {required: true, message: 'Bu Alan Boş Bırakılamaz'}
                        ]}
                    >
                        <DatePicker format={dateFormat} placeholder={'Tarih Seçiniz'}/>
                    </Form.Item>
                    <Form.Item
                        label={'Bitiş Tarihi'}
                        name={'productionEndDate'}
                        rules={[
                            {required: true, message: 'Bu Alan Boş Bırakılamaz'}
                        ]}
                    >
                        <DatePicker format={dateFormat} placeholder={'Tarih Seçiniz'}/>
                    </Form.Item>
                    <Form.Item
                        label={'Üretim Hattı'}
                        name={'productionLine'}
                        rules={[
                            {required: true, message: 'Bu Alan Boş Bırakılamaz'},
                            () => ({
                                validator(rule, value) {
                                    let hasValue = productionLines.filter(production => production.text.toLowerCase() === value.toLowerCase())
                                    if (value && hasValue.length > 0) {
                                        handleProdChange(true, {key: hasValue[0].value})
                                        return Promise.resolve();
                                    }

                                    return Promise.reject('Lütfen Geçerli Bir Değer Seçiniz');
                                },
                            }),
                        ]}
                    >
                        <AutoComplete
                            style={{minWidth: '75px'}}
                            // onChange={handleProdChange}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {productionLines.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        label={'Üretim Notu'}
                        name={'productionNotes'}
                    >
                        <TextArea/>
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default ProductionCreate